/**
 * Shared Tailwind class palette for Square Game cells.
 *
 * All three grids (SquareBoardPreview, SquareGrid, SquareGameStyleStandard)
 * consume this so status colors stay consistent across the app.
 *
 * `cell` holds the base color/border/text classes for the given status.
 * `hover` holds optional interactive hover overrides; consumers only apply
 * it when the cell is clickable.
 */
export const squarePalette = {
  available: {
    cell: 'bg-emerald-100 dark:bg-emerald-500/20 border-emerald-300 dark:border-emerald-400/30 text-emerald-800 dark:text-emerald-100',
    hover: 'hover:bg-emerald-200 dark:hover:bg-emerald-500/30 hover:border-emerald-400 dark:hover:border-emerald-400/60',
  },
  selected: {
    cell: 'bg-blue-200 dark:bg-blue-500/30 border-blue-500 dark:border-blue-400 text-blue-900 dark:text-white ring-2 ring-blue-500 dark:ring-blue-400',
    hover: '',
  },
  held: {
    cell: 'bg-amber-100 dark:bg-amber-500/15 border-amber-400 dark:border-amber-400/60 text-amber-900 dark:text-amber-200',
    hover: '',
  },
  taken: {
    cell: 'bg-slate-200 dark:bg-slate-600/60 border-slate-400 dark:border-slate-500 text-slate-700 dark:text-slate-300',
    hover: '',
  },
  sold: {
    cell: 'bg-slate-300 dark:bg-slate-700/80 border-slate-500 dark:border-slate-600 text-slate-800 dark:text-slate-400',
    hover: '',
  },
  winner: {
    cell: 'bg-yellow-200 dark:bg-yellow-500/30 border-yellow-500 dark:border-yellow-400 text-yellow-900 dark:text-yellow-100 ring-2 ring-yellow-500 dark:ring-yellow-400 animate-pulse',
    hover: '',
  },
};

export const squareStatusClass = (status) =>
  squarePalette[status] || squarePalette.available;
